import React from "react";
import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import UserDashBoardHeader from "../Component/user-dashboard/Header";
import { styled, useTheme } from "@mui/material/styles";
import { Outlet } from "react-router-dom";
import DashboadFooter from "../Component/user-dashboard/Footer";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(6, 3),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const DashBoardLayout = ({ logoutUser }) => {
  const theme = useTheme();
  return (
    <>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <UserDashBoardHeader logoutUser={logoutUser} />
        <Box component="main" sx={{ flexGrow: 1, p: 3, width: "100%" }}>
          <DrawerHeader theme={theme} />
          <Outlet />
        </Box>
        <DashboadFooter />
      </Box>
    </>
  );
};

export default DashBoardLayout;
